import { Group, Loader, NumberInput, Paper, Switch } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import { editPool, findPool } from "../../../../api/EmailAPI";
import { IconCheck, IconX } from "@tabler/icons-react";

const PoolControl = ({ pool }) => {
  const lang = useLanguage((s) => s.language);

  const [activating, setActivating] = useState(false);
  const [editing, setEditing] = useState(false);
  const [enabled, setEnabled] = useState(pool?.auto_remove_enabled);
  const [threshold, setThreshold] = useState(pool?.reputation_threshold || 0);

  const handleActivate = () => {
    setActivating(true);
    editPool({ id: pool.id, auto_remove_enabled: !enabled })
      .then(() => setEnabled(!enabled))
      .finally(() => setActivating(false));
  };

  const handleThreshold = () => {
    setEditing(true);
    editPool({ id: pool.id, reputation_threshold: threshold })
      .catch(() => setThreshold(pool.reputation_threshold))
      .finally(() => setEditing(false));
  };

  useEffect(() => {
    setEnabled(pool?.auto_remove_enabled);
    setThreshold(pool?.reputation_threshold || 0);
  }, [pool?.auto_remove_enabled, pool?.reputation_threshold]);

  return (
    <Paper component={Group} ml={16} p={"xs"} withBorder key={pool?.id}>
      <Switch
        checked={enabled}
        onChange={handleActivate}
        label={lang.pools.delete_control}
        size="md"
        thumbIcon={activating ? <Loader size={12} /> : undefined}
      />

      <NumberInput
        value={threshold}
        onChange={setThreshold}
        onBlur={handleThreshold}
        disabled={editing}
        size="md"
        w={75}
        min={0}
        max={100}
        clampBehavior="strict"
      />
    </Paper>
  );
};

export default PoolControl;
